import React from "react";

const OfferLabel = (props) => {
  return <div className="offer-label red-label">{props.offer}% OFF</div>;
};

export default OfferLabel;
